module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBdItalic.woff2?v=0170e2caa676269253a540fc0f4fe2df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBdItalic.woff2
// module id = 680
// module chunks = 0